const BackButtonTapped = {
  object_name: 'directDepositPDFBack',
  screen: 'directDepositPDF',
  screen_name: 'directDepositPDF',
  cta_title: '',
}

export { BackButtonTapped }
